import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CouponState } from '../../../../enums/coupon';
import store, { RootState } from '../../../../store';
import { setCoupon, startLoading, setClientRefresh, setValidatedCoupon } from '../../../../store/application';
import { newCartApi , getCart } from '../../../../store/newCart';
import { discountApi } from '../../../../store/discount';
import { config } from '../../../../utils/config';
import { discountCodeApi } from '../../../../store/discountCode';
import { Page } from '../../../../enums/page';

const IdleTimer = () => {
  const dispatch = useDispatch();
  const {
    applicationState: { user, clientRefresh,currentPage }
  }: any = useSelector((state: RootState) => state);

    useEffect(() => {
        let timerId;

        const resetTimer = () => {
            clearTimeout(timerId);
            timerId = setTimeout(() => {
              const cart = getCart(store.getState(), {cartId: user.cartId, userId: user.userId, isLoggedIn: user.isLoggedIn})?.data;
                if(cart){
                  dispatch(startLoading());
                  dispatch(setClientRefresh(true));
                  if(cart.validDiscountCode){
                    dispatch(setCoupon({ state: CouponState.INITIAL, code: '', description: '', error: '', details: '',thresholdValue : null}));
                    dispatch(setValidatedCoupon({ state: CouponState.INITIAL}))
                    dispatch(discountApi.endpoints.validateCoupon.initiate({ couponCode: cart.validDiscountCode , 'locale': config('locale') , callApplyCoupon: true, isAutoApplyCall: true}));
                  }else{
                    dispatch(newCartApi.util.invalidateTags(['newCart']));
                  }
                  if (config('locale') === 'en-US') {
                    const invalidateTag = !cart.appliedGlobalDiscountId && currentPage !== Page.CHECKOUTPAYMENT 
                        ? 'getCartDiscounts' 
                        : 'getDiscountByDiscountId';
            
                    dispatch(discountCodeApi.util.invalidateTags([invalidateTag]));
                  }
                }

                resetTimer();
            }, 30 * 60 * 1000);
        };

        const onUserActivity = () => {
            resetTimer();
        };
        const eventTypes = [
            "load",
            "mousemove",
            "mouseup",
            "mousedown",
            "keypress",
            "touchstart",
            "click",
        ];

        eventTypes.forEach((eventType) =>
            document.addEventListener(eventType, onUserActivity)
        );

        resetTimer();

        return () => {
            eventTypes.forEach((eventType) =>
                document.removeEventListener(eventType, onUserActivity)
            );
            clearTimeout(timerId);
        };
    }, []);

    return (
        <></>
    );
}

export default IdleTimer;
